import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { buildSuggestionTabTitleParams } from './SuggestionTabAlerts/buildSuggestionTabTitleParams';
import { getTabAlertTitleKey } from './SuggestionTabAlerts/getTabAlertTitleKey';
import { useDocumentTitleStore } from '../store/DocumentTitle/useDocumentTitleStore';
import { useSuggestionTabAlertsStore } from '../store/SuggestionTabAlerts/useSuggestionTabAlertsStore';

export function useDocumentTitleRenderer() {
  const { t } = useTranslation();
  const pageTitle = useDocumentTitleStore((s) => s.pageTitle);
  const unseenCount = useSuggestionTabAlertsStore((s) => s.unseenCount);
  const hasAttention = useSuggestionTabAlertsStore((s) => s.hasAttention);

  useEffect(() => {
    const appName = t('appName');
    document.title =
      unseenCount > 0
        ? t(
            getTabAlertTitleKey(hasAttention),
            buildSuggestionTabTitleParams(unseenCount, appName),
          )
        : (pageTitle ?? appName);
  }, [pageTitle, unseenCount, hasAttention, t]);
}
